import { useEffect } from 'react';

const useRefetchOnPageshow = (refetch: () => Promise<any>, hasPendingPayment: boolean) => {
  useEffect(() => {
    const pageShowHandler = (event: PageTransitionEvent) => {
      if (event.persisted && !hasPendingPayment) {
        refetch();
      }
    };

    window.addEventListener('pageshow', pageShowHandler);

    return () => window.removeEventListener('pageshow', pageShowHandler);
  }, [hasPendingPayment, refetch]);
};

export default useRefetchOnPageshow;
